import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import React, { useContext } from 'react';
import { RemoteControlContext } from '../ContextProvider';

export default function OrganizationList ({ data }) {
    const { currentOrg, setCurrentOrg } = useContext(RemoteControlContext);

    const org_id = currentOrg.id;
    const changeOrgHandler = (org) => {
        setCurrentOrg(org);
    };

    return (
        <List>
            {data.map((org) => (
                <ListItem key={org.id}>
                    <ListItemButton selected={org_id === org.id} onClick={() => changeOrgHandler(org)}>
                        <ListItemText>{org.name}</ListItemText>
                    </ListItemButton>
                </ListItem>))}
        </List>
    );
}
